import React, { FC } from "react";
import RoleCard from "../atoms/RoleCard";
// Interface defining the structure of a Role object
interface Role {
  id: number;
  name: string;
  updatedOn: string;
  createdBy: string
}

interface RoleListProps {
  roles: Role[];
  onDelete: (id: number) => void; 
}
// Functional component to render a list of roles
const RoleList: FC<RoleListProps> = ({ roles ,onDelete}) => {
  return (
    <>
      <ul style={{listStyle:'none'}} className="p-0">
      {roles.map((role) => (
        <div key={role.id}>
              <RoleCard role={role} onDelete={onDelete}/>
              {/* <AgentCard role={role} onDelete={onDelete}/> */}
        </div>
      ))}
      </ul>
    </>
  );
};

export default RoleList;
